import React, { useEffect, useState } from "react";
import {
    convertFromWei,
    convertFromWeiEthers,
    formatDates,
    formatTimeTo12Hour,
    getBackgroundColor,
    getFormatedWeb3Address,
    getTokenSymbol,
    handleToFixedOnDecimals,
} from "../../utils/helpers";
import TableLoader from "../../hooks/loaderTable";
import CustomPagination from "../CustomPagination";
import { getUserProfileHistory } from "../../utils/services";
import { MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from "../../utils/MarketStatus";
import { useTheme } from "../../contexts/ThemeProvider";
import LoaderTable from "../../hooks/loaderTable";
import { transactionType } from "../../utils/constants";

const HistoryTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [userHistory, setUserHistory] = useState([]);
    const theme = useTheme();
    const accessToken = localStorage.getItem("accessToken");

    const getUserHistory = async (offset = 1) => {
        if (!accessToken) {
            clearHistory();
            return;
        }

        setIsTableLoading(true);
        try {
            const data = await getUserProfileHistory(offset);
            setUserHistory(data.history || []);
            setTotalPages(data.pagination?.totalPages || 1);
        } catch (error) {
            console.error("Error fetching user points history:", error);
            clearHistory();
        } finally {
            setIsTableLoading(false);
        }
    };

    const clearHistory = () => {
        setUserHistory([]);
        setTotalPages(1);
        setCurrentPage(1);
        setIsTableLoading(false);
    };

    useEffect(() => {
        if (accessToken) {
            window.scrollTo(0, 0);
            getUserHistory(currentPage);
        } else {
            clearHistory();
        }
    }, [currentPage, accessToken]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <>
            {window.innerWidth > 991 ? (
                <div className="history-section">
                    <div className="parent">
                        <div className="upper-fields">
                            <p>Action</p>
                            <p>Details</p>
                            <p>Amount</p>
                            <p>Date & Time</p>
                            <p>TX Hash</p>
                        </div>

                        <div className="bottom-fields" style={{ minHeight: "400px" }}>
                            {isTableLoading ? (
                                <TableLoader />
                            ) : userHistory?.length > 0 ? (
                                userHistory?.map((item, idx) => {
                                    const action = transactionType[item.action] || transactionType[item.eventType] || "Unknown";
                                    const amount = item.amount ? convertFromWeiEthers(item.amount, item?.poolToken?.tokenDecimals) : item.value || 0;
                                    const txHash = item.txHash || item.transactionHash || "-";
                                    const cleanedHash = txHash.includes("/") ? txHash.split("/")[0] : txHash;
                                    const details = item.poolQuestion || item.eventType || "No Details";
                                    const optionName = item.optionName || null;

                                    return (
                                        <div className="single-field" key={idx}>
                                            <h6>{action}</h6>

                                            <div className="text">
                                                <h6>{details}</h6>
                                                {optionName && (
                                                    <p>
                                                        <span
                                                            className="circlebg"
                                                            style={{ backgroundColor: getBackgroundColor(idx, theme, userHistory.length) }}
                                                        ></span>
                                                        <span
                                                            className="livetext"
                                                            style={{
                                                                backgroundColor: MARKET_STATUS_BACKGROUNDS[item.status],
                                                                color: MARKET_STATUS_TEXT_COLORS[item.status],
                                                            }}
                                                        >
                                                            {optionName}
                                                        </span>
                                                    </p>
                                                )}
                                            </div>

                                            <h6 style={{ color: amount < 0 ? "#DB5F2B" : "#22AB00" }}>
                                                {getTokenSymbol(item?.poolToken?.tokenSymbol || item?.token?.tokenSymbol)} {handleToFixedOnDecimals(amount)}
                                            </h6>

                                            <h6>
                                                {formatDates(item?.createdAt)}{" "}
                                                <span className="grey">{formatTimeTo12Hour(item?.createdAt)}</span>
                                            </h6>

                                            {txHash && (
                                                <a
                                                    href={`https://arbiscan.io/tx/${txHash}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {getFormatedWeb3Address(cleanedHash, false)}
                                                    <a
                                                        href={`https://arbiscan.io/tx/${txHash}`}
                                                        className="innerlink"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path
                                                                d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                                                stroke="#727272"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M12.25 1.75L7 7"
                                                                stroke="#727272"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M8.75 1.75H12.25V5.25"
                                                                stroke="#727272"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </a>
                                                </a>
                                            )}
                                        </div>
                                    );
                                })
                            ) : (
                                <p style={{ textAlign: "center", marginTop: "1rem", color: "var(--text-color1)" }}>No history available.</p>
                            )}
                        </div>
                    </div>

                    {!isTableLoading && userHistory?.length > 0 && (
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            ) : (
                <div className="history-section-mbl">
                    <div className="parent-cards" style={{ minHeight: "400px" }}>
                        {isTableLoading ? (
                            <div className="pb-5 pt-5">
                                <LoaderTable />
                            </div>
                        ) : userHistory?.length > 0 ? (
                            userHistory?.map((item, idx) => {
                                const action = item.action || item.eventType || "Unknown";
                                const amount = item.amount ? convertFromWeiEthers(item.amount, item?.poolToken?.tokenDecimals) : item.value || 0;
                                const txHash = item.txHash || item.transactionHash || "-";
                                const details = item.poolQuestion || item.eventType || "No Details";
                                const optionName = item.optionName || null;

                                return (
                                    <div className="single-card" key={idx}>
                                        <div className="text">
                                            <p>Action</p>
                                            <h6>{action}</h6>
                                        </div>

                                        <div className="text">
                                            <p>Amount</p>
                                            <h6 style={{ color: amount < 0 ? "#DB5F2B" : "#22AB00" }}>
                                                {getTokenSymbol(item?.poolToken?.tokenSymbol || item?.token?.tokenSymbol)} {handleToFixedOnDecimals(amount)}
                                            </h6>
                                        </div>

                                        <div className="text">
                                            <p>Details</p>
                                            <div className="innertext">
                                                <h6>{details}</h6>
                                                {optionName && (
                                                    <p>
                                                        <span
                                                            className="circlebg"
                                                            style={{ backgroundColor: getBackgroundColor(idx, theme, userHistory?.length) }}
                                                        ></span>
                                                        <span
                                                            className="livetext"
                                                            style={{
                                                                backgroundColor: MARKET_STATUS_BACKGROUNDS[item.status],
                                                                color: MARKET_STATUS_TEXT_COLORS[item.status],
                                                            }}
                                                        >
                                                            {optionName}
                                                        </span>
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text">
                                            <p>Date & Time</p>
                                            <h6>
                                                {formatDates(item?.createdAt)}{" "}
                                                <span>{formatTimeTo12Hour(item?.createdAt)}</span>
                                            </h6>
                                        </div>

                                        <div className="text">
                                            <p>TRX Hash</p>
                                            {txHash && (
                                                <a
                                                    href={`https://arbiscan.io/tx/${txHash}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {getFormatedWeb3Address(txHash, false)}{" "}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path
                                                            d="M12.25 7.58333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H6.41667"
                                                            stroke="#7A7A7A"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M12.25 1.75L7 7"
                                                            stroke="#7A7A7A"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M8.75 1.75H12.25V5.25"
                                                            stroke="#7A7A7A"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p style={{ textAlign: "center", marginTop: "1rem", color: "var(--text-color1)" }}>No history available.</p>
                        )}
                    </div>

                    {!isTableLoading && userHistory?.length > 0 && (
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default HistoryTable;